 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLEPIGRAPH from '@/components/xhtml/Epigraph'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLCHAPTER001 from '@/components/xhtml/Chapter001'
 import XHTMLCHAPTER002 from '@/components/xhtml/Chapter002'
 import XHTMLCHAPTER003 from '@/components/xhtml/Chapter003'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/Abouttheauthor'
 import XHTMLPRAISE from '@/components/xhtml/Praise'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLABOUTTHEPUBLISHER from '@/components/xhtml/Aboutthepublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js